<section class="panel-expansion">
    <mat-accordion class="appplatforms" >
        <mat-expansion-panel class="mpanel" [expanded]="true" [disabled]="true">
            <mat-expansion-panel-header class="mpanel-header">{{'lang_project_platforms' | language }}</mat-expansion-panel-header>
            <div class="material-panel-body">
                <div class="mbrl15 martb0">
                    <div class="row">
                        <div class="col-md-2 col-xs-12 mb-10">
                            <ng-select 
                                [items]="group1lists" 
                                [multiple]="false" 
                                bindLabel="label" 
                                bindValue="value" 
                                appendTo="body" 
                                clearAllText="Clear"
                                placeholder="{{'lang_group' | language}} 1"
                                [(ngModel)]="group1model"
                                (change)="spinner.show();load_group_2_lists('filter');get_platform_lists();">
                            </ng-select>
                        </div>
                        <div class="col-md-2 col-xs-12 mb-10">
                            <ng-select 
                                [items]="typeslist" 
                                [multiple]="false" 
                                bindLabel="label" 
                                bindValue="value" 
                                appendTo="body" 
                                clearAllText="Clear"
                                placeholder="{{'lang_group_type' | language}}"
                                [(ngModel)]="typemodel"
                                (change)="spinner.show();load_group_2_lists('filter');get_platform_lists();">
                            </ng-select>
                        </div>
                        <div class="col-md-2 col-xs-12 mb-10">
                            <ng-select 
                                [items]="group2lists" 
                                [multiple]="false" 
                                bindLabel="label" 
                                bindValue="value" 
                                appendTo="body" 
                                clearAllText="Clear"
                                placeholder="{{'lang_group' | language}} 2"
                                [(ngModel)]="group2model"
                                (change)="spinner.show();get_platform_lists();">
                            </ng-select>
                        </div>
                        <div class="col-md-6 col-xs-12 mb-10">
                            <div class="input-group input-group-sm">
                                <input type="text" class="form-control almnabrformcontrol" (keyup)="get_platform_lists();" [(ngModel)]="searchKey" placeholder="{{'lang_search' | language }}">
                                <span class="input-group-btn">
                                    <button class="btnSearch h34 btn btn-md btn-gray fa fa-plus mnabricon" (click)="openModalA(platformAction);form.reset();selectmultiple = true;" id="btnSearch" type="button" matTooltip="{{'lang_add' | language }}"></button>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="table-responsive dropdownyes customResponsive">
                                <table border="1" class="table CustomTable">
                                    <thead>
                                        <tr>
                                            <td>#</td>
                                            <td>
                                                <div class="checkbox"  matTooltip="{{'lang_check_all' | language}}">
                                                    <input type="checkbox" class="allItemsWPL checkbox" id="allItemsWPL" (click)="checkAllItemsWPL($event)"/>
                                                    <label for="checkbox"></label>
                                                </div>
                                            </td>
                                            <td>{{'lang_group' | language }} 1</td>
                                            <td>{{'lang_group_type' | language }}</td>
                                            <td>{{'lang_group' | language }} 2</td>
                                            <td>{{'lang_title_english' | language }}</td>
                                            <td>{{'lang_title_arabic' | language }}</td>
                                            <td>{{'lang_system_code' | language }}</td>
                                            <td>{{'lang_manual_code' | language }}</td>
                                            <td>{{'lang_writer' | language }}</td>
                                            <td>{{'lang_action' | language }}</td>
                                        </tr>
                                    </thead>
                                    <tbody *ngIf="wholeData.length != '0' " class="AppendList">
                                        <tr *ngFor="let row of tabledata; let i = index;let odd=odd; let even=even" [ngClass]="{ odd: odd, even: even }" class="makeback removerow{{row.platform_id}}">
                                            <td>{{i+1}}</td>
                                            <td>
                                                <div class="checkbox" matTooltip="{{'lang_check' | language}}">
                                                    <input type="checkbox"  class="eachItemWPL checkbox" value="{{row.platform_id}}" (click)="checkEachItemWPL($event)"/>
                                                    <label for="checkbox"></label>
                                                </div>
                                            </td>
                                            <td>{{row.group1name}}</td>
                                            <td>{{row.typename}}</td>
                                            <td>{{row.group2name}}</td>
                                            <td>{{row.platform_subject_english}}</td>
                                            <td>{{row.platform_subject_arabic}}</td>
                                            <td>{{row.platform_code_system}}</td>
                                            <td *ngIf="row.platform_code_manual">{{row.platform_code_manual}}</td>
                                            <td *ngIf="!row.platform_code_manual">----</td>
                                            <td>{{row.writer}}</td>
                                            <td>
                                                <i class="fa fa-eye s2icon fa-icon mnabricon" matTooltip="{{'lang_view' | language }}" (click)="openModalV(platformView);viewdata = row"></i>
                                                <i class="fa fa-pencil-square-o s2icon fa-icon mnabricon" matTooltip="{{'lang_edit' | language }}" (click)="openModalA(platformAction);form.patchValue(row);load_group_2_lists('form');selectmultiple = false;"></i>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody *ngIf="wholeData.length == '0' " class="AppendList">
                                        <tr class="odd">
                                            <td colspan="11" align="center">{{nodata}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="tabledata?.length != '0' " class="card-footer padb0">
                    <div class="row">
                        <div *ngIf="admin" class="deleteIconDiv none col-lg-1 col-sm-6 col-6 mb-10">
                            <i class="fa fa-trash-o faicon red deleteIcon" (click)="deleteBulkDataWPL();" aria-hidden="true" matTooltip="{{'lang_delete' | language }}"></i>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-6 mb-10">
                            {{'lang_total' | language }} : {{collectionSize}}
                        </div>
                        <div class="col-lg-5 col-sm-6 mb-10">
                            <ngb-pagination [collectionSize]="collectionSize" [maxSize]="3" [rotate]="true" [ellipses]="false" [boundaryLinks]="true" [(page)]="page" [pageSize]="pageSize" (pageChange)="build_table_data()"></ngb-pagination>
                        </div>
                        <div class="col-lg-3 col-sm-6">
                            <select class="customselect" [(ngModel)]="pageSize" (change)="build_table_data()">
                                <option [ngValue]="10">10</option>
                                <option [ngValue]="20">20</option>
                                <option [ngValue]="50">50</option>
                                <option [ngValue]="100">100</option>
                                <option [ngValue]="250">250</option>
                                <option [ngValue]="500">500</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</section>
<ng-template #platformAction>
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">{{'lang_project_platforms' | language }} </h4>
            <button type="button" class="close" data-dismiss="modal" (click)="modalRefA.hide();">&times;</button>
        </div>
        <form [formGroup]="form" (ngSubmit)="submit();">
            <div class="modal-body">
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <label for="platform_code_manual">{{'lang_manual_code' | language }} : </label>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <input type="text" class="form-control almnabrformcontrol" formControlName="platform_code_manual" placeholder="{{'lang_manual_code' | language }}"/>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <label for="platform_subject_english">{{'lang_title_english' | language }} : <span class="red">*</span></label>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <input type="text" class="form-control almnabrformcontrol" formControlName="platform_subject_english" placeholder="{{'lang_title_english' | language }}"/>
                            <mat-error *ngIf="form.controls['platform_subject_english'].touched && form.controls['platform_subject_english'].errors?.required"> {{'lang_field_required' | language }} </mat-error>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <label for="platform_subject_arabic">{{'lang_title_arabic' | language }} : <span class="red">*</span></label>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <input type="text" class="form-control almnabrformcontrol" formControlName="platform_subject_arabic" placeholder="{{'lang_title_arabic' | language }}"/>
                            <mat-error *ngIf="form.controls['platform_subject_arabic'].touched && form.controls['platform_subject_arabic'].errors?.required"> {{'lang_field_required' | language }} </mat-error>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <label for="platform_descriptions_english">{{'lang_desc_english' | language }} : <span class="red">*</span></label>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <input type="text" class="form-control almnabrformcontrol" formControlName="platform_descriptions_english" placeholder="{{'lang_desc_english' | language }}"/>
                            <mat-error *ngIf="form.controls['platform_descriptions_english'].touched && form.controls['platform_descriptions_english'].errors?.required"> {{'lang_field_required' | language }} </mat-error>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <label for="platform_descriptions_arabic">{{'lang_desc_arabic' | language }} : <span class="red">*</span></label>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <input type="text" class="form-control almnabrformcontrol" formControlName="platform_descriptions_arabic" placeholder="{{'lang_desc_arabic' | language }}"/>
                            <mat-error *ngIf="form.controls['platform_descriptions_arabic'].touched && form.controls['platform_descriptions_arabic'].errors?.required"> {{'lang_field_required' | language }} </mat-error>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <label for="platform_group1_code_system">{{'lang_group' | language }} : 1 <span class="red">*</span></label>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <ng-select 
                                [items]="group1lists" 
                                [multiple]="false" 
                                bindLabel="label" 
                                bindValue="value" 
                                appendTo="body" 
                                clearAllText="Clear"
                                placeholder="{{'lang_group' | language}} 1"
                                formControlName="platform_group1_code_system"
                                (change)="load_group_2_lists('form');">
                            </ng-select>
                            <mat-error *ngIf="form.controls['platform_group1_code_system'].touched && form.controls['platform_group1_code_system'].errors?.required"> {{'lang_field_required' | language }} </mat-error>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <label for="platform_group_type_code_system">{{'lang_group_type' | language }} : <span class="red">*</span></label>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <ng-select 
                                [items]="typeslist" 
                                [multiple]="selectmultiple" 
                                bindLabel="label"
                                bindValue="value"
                                appendTo="body" 
                                clearAllText="Clear"
                                placeholder="{{'lang_group_type' | language}}"
                                formControlName="platform_group_type_code_system"
                                (change)="load_group_2_lists('form');">
                            </ng-select>
                            <mat-error *ngIf="form.controls['platform_group_type_code_system'].touched && form.controls['platform_group_type_code_system'].errors?.required"> {{'lang_field_required' | language }} </mat-error>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <label for="platform_subject_arabic">{{'lang_group' | language }} : 2 <span class="red">*</span></label>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <ng-select 
                                [items]="group2formlists" 
                                [multiple]="false" 
                                bindLabel="label" 
                                bindValue="value" 
                                appendTo="body" 
                                clearAllText="Clear"
                                placeholder="{{'lang_group' | language}} 2"
                                formControlName="platform_group2_code_system">
                            </ng-select>
                            <mat-error *ngIf="form.controls['platform_group2_code_system'].touched && form.controls['platform_group2_code_system'].errors?.required"> {{'lang_field_required' | language }} </mat-error>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer pad15">
                <div class="row">
                    <div class="col-12 mb-10">
                        <app-alert id="default-alert"></app-alert>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-xs-12 mb-10">
                        <button type="submit" class="albutton">{{'lang_submit' | language }}</button>
                    </div>
                    <div class="col-md-6 col-xs-12 mb-10">
                        <button type="button" class="btn btn-secondary secondarybutton" data-dismiss="modal" (click)="modalRefA.hide();">{{'lang_close' | language }}</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-template>
<ng-template #platformView>
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">{{'lang_project_platforms' | language }} ({{'lang_view' | language}})</h4>
            <button type="button" class="close" data-dismiss="modal" (click)="modalRefV.hide();">&times;</button>
        </div>
        <div class="modal-body">
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <label for="platform_code_manual">{{'lang_system_code' | language }} </label>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div> : 
                            <b>{{viewdata.platform_code_system}}</b>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <label for="platform_code_manual">{{'lang_manual_code' | language }} </label>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div> : 
                            <b *ngIf="viewdata.platform_code_manual">{{viewdata.platform_code_manual}}</b>
                            <b *ngIf="!viewdata.platform_code_manual">----</b>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <label for="platform_subject_english">{{'lang_title_english' | language }}</label>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div> : <b>{{viewdata.platform_subject_english}}</b></div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <label for="platform_subject_arabic">{{'lang_title_arabic' | language }}</label>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div> : <b>{{viewdata.platform_subject_arabic}}</b></div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <label for="platform_descriptions_english">{{'lang_desc_english' | language }}</label>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div> : <b>{{viewdata.platform_descriptions_english}}</b></div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <label for="platform_descriptions_arabic">{{'lang_desc_arabic' | language }}</label>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div> : <b>{{viewdata.platform_descriptions_arabic}}</b></div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <label for="platform_group1_code_system">{{'lang_group' | language }} 1 </label>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div> : <b>{{viewdata.group1name}} - {{viewdata.platform_group1_code_system}}</b></div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <label for="platform_group_type_code_system">{{'lang_group_type' | language }}</label>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div> : <b>{{viewdata.typename}} - {{viewdata.platform_group_type_code_system}}</b></div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <label for="platform_subject_arabic">{{'lang_group' | language }} 2 </label>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div> : <b>{{viewdata.group2name}} - {{viewdata.platform_group2_code_system}}</b></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer pad15">
            <div class="row">
                <div class="col-10"></div>
                <div class="col-2">
                    <button type="button" class="btn btn-secondary secondarybutton" data-dismiss="modal" (click)="modalRefV.hide();">{{'lang_close' | language }}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>